import { useEffect, useState } from "react";

import type { HeroSlide } from "../types/marketplace";
import { formatNumber } from "../utils/formatters";

const previousIcon = "\u2039";
const nextIcon = "\u203A";

interface CarouselProps {
  slides: HeroSlide[];
  interval?: number;
}

function Carousel({ slides, interval = 6000 }: CarouselProps) {
  const [activeIndex, setActiveIndex] = useState<number>(0);
  const activeSlide = slides[activeIndex];

  useEffect(() => {
    if (slides.length <= 1) {
      return undefined;
    }

    const timerId = window.setInterval(() => {
      setActiveIndex((currentIndex) => (currentIndex + 1) % slides.length);
    }, interval);

    return () => window.clearInterval(timerId);
  }, [interval, slides.length]);

  if (!activeSlide) {
    return null;
  }

  const goToPrevious = () => {
    setActiveIndex((currentIndex) =>
      currentIndex === 0 ? slides.length - 1 : currentIndex - 1
    );
  };

  const goToNext = () => {
    setActiveIndex((currentIndex) => (currentIndex + 1) % slides.length);
  };

  return (
    <section className="hero-wrap">
      <div className="container">
        <div className="hero-card" style={{ background: activeSlide.background }}>
          <button
            aria-label="Anterior"
            className="hero-arrow left"
            onClick={goToPrevious}
            type="button"
          >
            {previousIcon}
          </button>

          <div className="hero-content">
            <span className="pill">{activeSlide.eyebrow}</span>
            <h1>{activeSlide.title}</h1>
            <p>{activeSlide.description}</p>
            <button className="primary-button" type="button">
              {activeSlide.cta}
            </button>
          </div>

          <button
            aria-label="Siguiente"
            className="hero-arrow right"
            onClick={goToNext}
            type="button"
          >
            {nextIcon}
          </button>

          <div className="hero-dots" aria-label="Seleccionar banner">
            {slides.map((slide, index) => (
              <button
                aria-label={`Ver banner ${formatNumber(index + 1)}`}
                className={index === activeIndex ? "current" : ""}
                key={slide.title}
                onClick={() => setActiveIndex(index)}
                type="button"
              />
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}

export default Carousel;
